var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _g3, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExerice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 147,
    viewBox: "0 0 263 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99 107C125.51 107 147 85.5097 147 59C147 32.4903 125.51 11 99 11C72.4903 11 51 32.4903 51 59C51 85.5097 72.4903 107 99 107Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 142C133.719 142 157 118.719 157 90C157 61.2812 133.719 38 105 38C76.2812 38 53 61.2812 53 90C53 118.719 76.2812 142 105 142Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141 147C169.719 147 193 123.719 193 95C193 66.2812 169.719 43 141 43C112.281 43 89 66.2812 89 95C89 123.719 112.281 147 141 147Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151 116C179.719 116 203 92.7188 203 64C203 35.2812 179.719 12 151 12C122.281 12 99 35.2812 99 64C99 92.7188 122.281 116 151 116Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128 100C154.51 100 176 78.5097 176 52C176 25.4903 154.51 4 128 4C101.49 4 80 25.4903 80 52C80 78.5097 101.49 100 128 100Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 76,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 60,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 235,
    cy: 141,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.5,
    cy: 2.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 143.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11356_10832)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.667 25.3333C109.667 22.9401 111.607 21 114 21H127H140C142.394 21 144.334 22.9401 144.334 25.3333C144.334 27.7266 142.394 29.6667 140 29.6667H131.333V38.5469C139.229 39.3308 146.502 42.2344 152.575 46.6807L159.127 40.1279L156.064 37.0645C154.372 35.3722 154.372 32.6285 156.064 30.9362C157.756 29.2439 160.5 29.2439 162.192 30.9362L168.32 37.0638L174.449 43.1927C176.141 44.885 176.141 47.6287 174.449 49.321C172.756 51.0132 170.013 51.0132 168.32 49.321L165.256 46.2562L159.031 52.4804C166.052 60.1815 170.334 70.4239 170.334 81.6663C170.334 105.599 150.933 125 127 125C103.068 125 83.667 105.599 83.667 81.6663C83.667 59.1967 100.769 40.7215 122.666 38.547V29.6667H114C111.607 29.6667 109.667 27.7266 109.667 25.3333ZM126.949 46.9997C107.827 47.0274 92.3337 62.5375 92.3337 81.6663C92.3337 100.812 107.854 116.333 127 116.333C146.146 116.333 161.667 100.812 161.667 81.6663C161.667 62.5372 146.173 47.0267 127.05 46.9997C127.034 46.9999 127.017 47 127 47C126.983 47 126.966 46.9999 126.949 46.9997Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127,
    cy: 81.6663,
    r: 43.3333,
    fill: "#FFF1CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127 116.333C146.146 116.333 161.667 100.812 161.667 81.6663C161.667 62.5205 146.146 46.9997 127 46.9997C107.854 46.9997 92.3337 62.5205 92.3337 81.6663C92.3337 100.812 107.854 116.333 127 116.333ZM127 125C150.933 125 170.334 105.599 170.334 81.6663C170.334 57.734 150.933 38.333 127 38.333C103.068 38.333 83.667 57.734 83.667 81.6663C83.667 105.599 103.068 125 127 125Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.936 65.6029C112.628 63.9106 115.372 63.9106 117.064 65.6029L130.064 78.6029C131.757 80.2951 131.757 83.0389 130.064 84.7311C128.372 86.4234 125.628 86.4234 123.936 84.7311L110.936 71.7311C109.244 70.0388 109.244 67.2951 110.936 65.6029Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127,
    cy: 81.6663,
    r: 4.33333,
    transform: "rotate(-90 127 81.6663)",
    stroke: "#24284E",
    strokeWidth: 8.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11356_10832)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.273 22.9509C197.386 21.6672 198.517 20.7175 199.801 20.8298L213.748 22.05C215.032 22.1623 215.981 23.2941 215.869 24.5778C215.757 25.8616 214.625 26.8113 213.341 26.6989L208.692 26.2922L208.275 31.056C212.474 31.8471 216.239 33.746 219.287 36.416L223.11 33.2083L221.611 31.4213C220.782 30.4342 220.911 28.9624 221.898 28.1341C222.885 27.3057 224.357 27.4345 225.185 28.4217L231.185 35.5714C232.013 36.5586 231.884 38.0303 230.897 38.8587C229.91 39.687 228.438 39.5583 227.61 38.5711L226.11 36.7831L222.478 39.8301C225.883 44.2906 227.699 49.9856 227.171 56.016C226.048 68.8537 214.731 78.3501 201.893 77.227C189.055 76.1038 179.559 64.7864 180.682 51.9488C181.737 39.8957 191.778 30.7879 203.626 30.6493L204.043 25.8854L199.394 25.4788C198.111 25.3664 197.161 24.2347 197.273 22.9509ZM205.539 35.3855C195.275 34.4953 186.229 42.0902 185.331 52.3555C184.433 62.6256 192.03 71.6795 202.3 72.5781C212.57 73.4766 221.624 65.8794 222.522 55.6093C223.42 45.344 215.831 36.2937 205.568 35.388C205.563 35.3876 205.558 35.3872 205.554 35.3868C205.549 35.3864 205.544 35.386 205.539 35.3855Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.928,
    cy: 53.9823,
    r: 23.3333,
    transform: "rotate(5 203.928 53.9823)",
    fill: "#FFF1CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.3 72.5789C212.57 73.4774 221.624 65.8803 222.522 55.6102C223.421 45.3401 215.824 36.2861 205.554 35.3876C195.284 34.4891 186.23 42.0863 185.331 52.3563C184.433 62.6264 192.03 71.6804 202.3 72.5789ZM201.893 77.2278C214.731 78.3509 226.048 68.8545 227.171 56.0169C228.294 43.1793 218.798 31.8619 205.96 30.7387C193.123 29.6156 181.805 39.112 180.682 51.9496C179.559 64.7872 189.055 76.1047 201.893 77.2278Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.064 44.6125C197.051 43.7841 198.523 43.9129 199.351 44.9001L205.714 52.4835C206.543 53.4707 206.414 54.9425 205.427 55.7708C204.44 56.5991 202.968 56.4704 202.139 55.4832L195.776 47.8997C194.948 46.9126 195.077 45.4408 196.064 44.6125Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.927,
    cy: 53.9824,
    r: 2.33333,
    transform: "rotate(-85 203.927 53.9824)",
    stroke: "#24284E",
    strokeWidth: 4.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11356_10832)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8086 75.2234C39.6739 73.9418 40.6037 72.7936 41.8853 72.6589L55.8086 71.1955C57.0902 71.0608 58.2383 71.9906 58.373 73.2722C58.5077 74.5538 57.578 75.7019 56.2964 75.8366L51.6552 76.3244L52.1551 81.0803C56.4276 81.0557 60.4856 82.2012 63.9875 84.2403L67.1279 80.3622L65.3149 78.894C64.3134 78.083 64.159 76.6137 64.9699 75.6122C65.7809 74.6107 67.2502 74.4563 68.2517 75.2673L75.5051 81.1409C76.5065 81.9519 76.661 83.4212 75.85 84.4227C75.039 85.4242 73.5697 85.5786 72.5682 84.7676L70.7546 83.299L67.7717 86.9826C71.9652 90.7115 74.8345 95.9556 75.4672 101.976C76.8143 114.792 67.5168 126.274 54.7007 127.621C41.8847 128.968 30.4032 119.67 29.0562 106.854C27.7915 94.8214 35.91 83.9651 47.514 81.5682L47.0141 76.8122L42.3731 77.3C41.0915 77.4347 39.9433 76.505 39.8086 75.2234ZM70.8261 102.464C71.9038 112.717 64.4658 121.902 54.2129 122.98C43.9601 124.057 34.7749 116.619 33.6973 106.366C32.6197 96.1135 40.0577 86.9283 50.3105 85.8507C60.5634 84.7731 69.7485 92.2111 70.8261 102.464Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.2617,
    cy: 104.414,
    r: 23.3333,
    transform: "rotate(-6 52.2617 104.414)",
    fill: "#FFF1CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2129 122.978C64.4657 121.901 71.9037 112.716 70.8261 102.463C69.7485 92.2099 60.5633 84.7719 50.3105 85.8496C40.0577 86.9272 32.6197 96.1123 33.6973 106.365C34.7749 116.618 43.9601 124.056 54.2129 122.978ZM54.7007 127.619C67.5167 126.272 76.8142 114.791 75.4672 101.975C74.1202 89.1589 62.6388 79.8614 49.8227 81.2085C37.0066 82.5555 27.7092 94.0369 29.0562 106.853C30.4032 119.669 41.8846 128.967 54.7007 127.619Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7545 96.716C43.5655 95.7145 45.0348 95.56 46.0363 96.371L53.7297 102.601C54.7311 103.412 54.8856 104.881 54.0746 105.883C53.2636 106.884 51.7943 107.039 50.7928 106.228L43.0995 99.9977C42.098 99.1867 41.9436 97.7174 42.7545 96.716Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.2607,
    cy: 104.414,
    r: 2.33333,
    transform: "rotate(-96 52.2607 104.414)",
    stroke: "#24284E",
    strokeWidth: 4.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M232.5 25.5L247.5 22",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M209.5 110.5L228.5 115",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15L41.5 22",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3 127.5L18 124",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11356_10832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white",
    transform: "translate(75 21)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11356_10832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(178.881 19) rotate(5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11356_10832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(21 74.8535) rotate(-6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerice);
export default __webpack_public_path__ + "static/media/exerice.b3328d4657d877af5eccab1cff8c0c9c.svg";
export { ForwardRef as ReactComponent };